<mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
  <mat-expansion-panel-header>
    <mat-panel-title>Import an Xlsx File </mat-panel-title>
    <mat-panel-description> {{ xlsxFunction.name }} : DB </mat-panel-description>
  </mat-expansion-panel-header>
  <div class="file-container">
    <mat-form-field class="toto2" appearance="fill" fxFlex>
      <mat-label>test File</mat-label>
      <input
        matInput
        placeholder="Select a file to upload"
        value="{{ selectedSimpleFileInput !== undefined ? selectedSimpleFileInput.item(0).name : null }}"
        (click)="fileImportInput.click()"
      />
      <input hidden (change)="selectSimpleFileInput($event)" #fileImportInput type="file" id="fileImportInput" accept=".xlsx" />
      <mat-hint>File type : Xlsx</mat-hint>
      <button mat-raised-button color="primary" matSuffix (click)="fileImportInput.click()">Choose file</button>
    </mat-form-field>
  </div>
  <div class="btn-container">
    <button (click)="onSend()" mat-flat-button>Send <span class="material-icons"> send </span></button>
  </div>

  @if (importFileXlsxStatus !== undefined) {
  <h5 class="title-historique">Last use</h5>
  <div class="historique">
    <div class="historique-body">
      <span matTooltip="userName" [matTooltipPosition]="'above'" class="material-icons"> person </span>
      <p>{{ importFileXlsxStatus.userName }}</p>
    </div>
    <div class="historique-body">
      <span matTooltip="StartDate" [matTooltipPosition]="'above'" class="material-icons"> hourglass_top </span>
      <p>{{ importFileXlsxStatus.startDate }}</p>
    </div>
    <div class="historique-body">
      <span matTooltip="EndDate" [matTooltipPosition]="'above'" class="material-icons"> hourglass_bottom </span>
      <p>{{ importFileXlsxStatus.updateDate }}</p>
    </div>
    <div class="historique-body">
      <mic-icon icon="monitoring"></mic-icon>
      <p>{{ importFileXlsxStatus.status }}</p>
    </div>
    <a [href]="test" class="file_download"><mic-icon icon="file_download"></mic-icon></a>
  </div>
  <mat-tab-group>
    @for (sheet of importFileXlsxStatus.importFileCsvStatuses; track sheet.id) {
    <mat-tab>
      <ng-template mat-tab-label>
        <div class="toto">
          {{ sheet.fileName }}
          <mat-icon [class]="sheet.status">{{ utilService.getTableRowStatusIcon(sheet.status) }}</mat-icon>
        </div>
      </ng-template>
      <div class="historic-sheet">
        @if (sheet.status === 'OK') {
        <p>The sheet was inserted successfully</p>
        } @if (sheet.status === 'KO') { @for (error of sheet.errorList; track $index) {
        <ul>
          <li class="warning-container">
            <span class="warning"><mic-icon icon="warning"></mic-icon></span>The error is in the column {{ error.columnNumber }} in the line
            {{ error.line }}. The value does not respect the regular expression that must be used.
          </li>
        </ul>
        } } @if (sheet.status === 'HELP') {
        <p>The sheet {{ sheet.fileName }} was not Found</p>
        }
      </div>
    </mat-tab>
    }
  </mat-tab-group>
  } @if (importFileXlsxStatus === undefined) {
  <mic-progress-bar color="accent" mode="indeterminate" ariaLabel="In Progress"></mic-progress-bar>
  }

  <div style="display: flex; justify-content: space-between">
    <mic-icon style="cursor: pointer" (click)="openXlsxHistoric()" icon="history"></mic-icon>
    <mic-icon style="cursor: pointer" (click)="openUpdatedCsvFunction()" icon="settings"></mic-icon>
  </div>
</mat-expansion-panel>
